import React, { useEffect, useRef, useState } from 'react';
import config from '../../../config';

const VerticalMarquee = ({
    items,
    speed = 50,
    auctionData,
}) => {
    const contentRef = useRef(null);
    const duplicatedItems = [...items, ...items];
    const [animationDuration, setAnimationDuration] = useState('20s');

    useEffect(() => {
        if (contentRef.current) {
            const totalHeight = contentRef.current.scrollHeight / 2;
            const durationInSeconds = totalHeight / speed;
            setAnimationDuration(`${durationInSeconds}s`);
        }
    }, [items, speed]);

    return (
        <div ref={contentRef}
            className={`vertical-marquee-content`}
            style={{ '--animation-duration': animationDuration }}
        >
            {duplicatedItems.map((lot, index) => (
                <div
                    key={index} style={{ height: '10.42vw',  marginBottom: '2.08vw' }}
                    className="flex items-center h-[200px] rounded-[12px] w-full shadow-md 
                        backdrop-blur-sm border-[1px] border-[#E6E6E6]">
                    <div className="w-[10%] h-full bg-black flex flex-col items-center justify-center rounded-l-[12px]">
                        <div className="text-white font-bold" style={{ fontSize: '1.7vw' }} >
                            Lot {lot.lot_number}</div>
                    </div>
                    <div className="w-[25%] h-full bg-[#F4F4F5] border-r-[1px] border-r-[#315B44]
                            flex flex-col items-center justify-center gap-[0.21vw] "
                    >
                        <div className="font-bold" style={{ fontSize: '1.46vw' }} >
                            {!lot.current_bid || lot.current_bid == 0 ? 'STARTING BID' : 'CURRENT BID'}
                        </div>
                        <div className="font-semibold text-[#0B8743]" style={{ fontSize: '1.82vw' }} >
                            {Number(!lot.current_bid || lot.current_bid == 0 
                                ? lot.starting_price : 
                                lot.current_bid).toLocaleString(auctionData?.currency ==='INR' ? 'en-IN' : 'en-US', {
                                style: 'currency',
                                currency: auctionData?.currency,
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })}
                        </div>
                        {lot.paddle_number!==undefined && lot.paddle_number!==0 && <div style={{ fontSize: '1.04vw' }} >
                            PADDLE {lot.paddle_number}</div>}
                    </div>
                    <div className="h-full w-[45%] flex-grow bg-white font-medium flex items-center justify-center px-4"
                        style={{ fontSize: '1.51vw' }} >
                        <div className="min-w-0 overflow-hidden text-ellipsis text-center line-clamp-3">
                            {lot.title1}
                        </div>
                    </div>
                    <div className="h-full w-[20%] rounded-r-[12px] overflow-hidden bg-black/40">
                        <img
                            className="w-full h-full object-contain"
                            src={`${config.Storage.CDN}${lot.images.find((image) => image.featured).url}`} 
                            alt="Lot Image"
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default VerticalMarquee;
